import React from "react";

// Canonical Nauticus mark: a circular compass (ring + directional needle) in GOLD.
// This is the single brand mark used everywhere (replaces earlier lighthouse variants).
export function NauticusMark({ className = "w-7 h-7", gold = "#D4AF37" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true" data-testid="nauticus-mark">
      <circle cx="12" cy="12" r="10" stroke={gold} strokeWidth="1.6" />
      <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88" fill={gold} />
      <circle cx="12" cy="12" r="1.1" fill="#0B192C" />
    </svg>
  );
}

// Shared brand lockup: gold compass + serif uppercase NAUTICUS wordmark in WHITE on NAVY.
// light=true  → placed directly on a dark/navy surface (transparent backing, white wordmark).
// light=false → placed on a light surface; wrapped in a navy backing so the wordmark stays white-on-navy.
export function NauticusLogo({ light = false, className = "" }) {
  if (light) {
    return (
      <div className={`inline-flex items-center gap-2.5 ${className}`} data-testid="nauticus-logo">
        <NauticusMark className="w-7 h-7" />
        <span className="font-display font-bold tracking-[0.18em] text-xl text-white">NAUTICUS</span>
      </div>
    );
  }
  return (
    <div className={`inline-flex items-center gap-2 rounded-lg bg-[#0B192C] px-2.5 py-1.5 ${className}`} data-testid="nauticus-logo">
      <NauticusMark className="w-6 h-6" />
      <span className="font-display font-bold tracking-[0.16em] text-lg text-white">NAUTICUS</span>
    </div>
  );
}
